bq.documentFormAjaxModal = function(element, options) {
    this.options   = options;
    this.$element  = $(element);
    this.$modal = false;
    this.$title = false;
    this.$body = false;
    this.$successButton = false;
};

bq.documentFormAjaxModal.DEFAULTS = {
    modal: '#document_form_ajax_modal',
    title: '#document_form_ajax_modal .modal-title',
    body: '#document_form_ajax_modal .modal-body .element-label',
    successButton: '#document_form_ajax_modal .btn-primary',
};

bq.documentFormAjaxModal.prototype = {
    init: function() {
        this.$modal = $(this.options.modal);
        this.$title = $(this.options.title);
        this.$body = $(this.options.body);
        this.$successButton = $(this.options.successButton);
        this.$element.off('click').on('click', {context: this}, this._showModal);
    },

    _showModal: function (e) {
        var $this = e.data.context;
        $this.$title.html($this.$element.attr('data-header-text'));
        $this.$body.html($this.$element.attr('data-body-text'));
        $this.$successButton.attr('data-id', $this.$element.attr('data-id'));
        $this.$modal.modal('show');
    },
};

// PLUGIN DEFINITION
// =======================

var documentFormAjaxModalOld = $.fn.documentFormAjaxModal;

$.fn.documentFormAjaxModal = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.documentFormAjaxModal');
        var options = $.extend({}, bq.documentFormAjaxModal.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.documentFormAjaxModal', (data = new bq.documentFormAjaxModal(this, options))); }
        data.init();
    });
};

$.fn.documentFormAjaxModal.Constructor = bq.documentFormAjaxModal;

// DOCUMENT FORM AJAX MODAL NO CONFLICT
// =================

$.fn.documentFormAjaxModal().noConflict = function () {
    $.fn.documentFormAjaxModal = documentFormAjaxModalOld();
    return this;
};

// DOCUMENT FORM AJAX MODAL DATA-API
// ==============

bq.documentFormAjaxModalInit = function() {
    $('[data-bq="document-form-ajax-modal"]').each(function () {
        var $el = $(this);
        $el.documentFormAjaxModal($el.data());
    });
};

bq.init.push(bq.documentFormAjaxModalInit);